import { Color3, Color4, Plane } from 'babylonjs';

export const SLICE_TOOL_CONFIG = {
  CLIP_PLANE_NORMAL: new Plane(0, 1, 0, 0).normal,
  GRID_RATIO: 4,
  MAJOR_UNIT_FREQUENCY: 8,
  MINOR_UNIT_VISIBILITY: 0.9,
  GRID_OPACITY: 0.99,
  MAIN_COLOR_OPACITY: 0.6,

  TOP_SLICE: {
    NAME: 'TopSlice',
    MATERIAL_NAME: 'TopSliceMat',
    MAIN_COLOR: new Color3(0.55, 0.96, 0.55),
    LINE_COLOR: new Color3(0.55, 0.96, 0.55),
    POSITION_Y: 40,
  },
  BOTTOM_SLICE: {
    NAME: 'BottomSlice',
    MATERIAL_NAME: 'BottomSliceMat',
    MAIN_COLOR: new Color3(0.96, 0.55, 0.55),
    LINE_COLOR: new Color3(0.96, 0.55, 0.55),
    POSITION_Y: -3,
  },
};

export const BOTTOM_SLICE_TOOL_CONFIG = {
  NAME: 'BottomSlice',
};

// How many tiles will be loaded on default (without changing input)
export const DEFAULT_TILE_LOAD = {
  DEFAULT_TILE_LOAD: [0, 1],
};

export const ENGINE_BACKGROUND = {
  color: new Color4(0.99, 0.99, 0.99, 1),
};

export const SCENE_CONFIG = {
  editMode: true,
};
